import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5153a358&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5153a358&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=5153a358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153a358",
  null
  
)

/* custom blocks */
import block0 from "~/lang/blog?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230531152404%2Fpages%2Fguides%2F_category%2F_slug%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230531152404/components/widgets/image.vue').default,SiteBlogArticleAuthor: require('/home/ubuntu/nuxt/bonkers/releases/20230531152404/components/site/blog/article/author.vue').default,WidgetsSocialFbComments: require('/home/ubuntu/nuxt/bonkers/releases/20230531152404/components/widgets/social/fb-comments.vue').default,SiteBlogArticleAside: require('/home/ubuntu/nuxt/bonkers/releases/20230531152404/components/site/blog/article/aside.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230531152404/components/site/feefo.vue').default})
